const { isArray } = require('lodash');
const { getAxiosInstance } = require('../connection');
const encodeQueryParams = require('../encodeQueryParams');

module.exports = {
    programItemSelection: function (programItem, select, options = {}) {
        const {userId, participantId} = options,
            data = {
                select: select ?? false,
            };

        if (userId) data.user_id = userId;
        if (participantId) data.participant_id = participantId;

        return getAxiosInstance({
            url: '/program_item/' + encodeURIComponent(programItem) + '/select',
            method: 'POST',
            data,
        }).then(response => response.data);
    },
    rateProgramItem: function (programItem, rating) {
        return getAxiosInstance({
            url: ['', 'program_item', encodeURIComponent(programItem), 'rate'].join('/'),
            method: 'POST',
            data: {rating},
        }).then(response => response.data);
    },
    fetchUserEvents: function (userId) {
        return getAxiosInstance({
            url: '/users/' + encodeURIComponent(userId) + '/events',
            method: 'GET',
        }).then(response => response.data);
    },
    fetchEvent: function (userId, eventId) {
        return getAxiosInstance({
            url: ['', 'users', encodeURIComponent(userId), 'events', encodeURIComponent(eventId)].join('/'),
            method: 'GET',
        }).then(response => response.data);
    },
    addEvent: function (userId, code) {
        return getAxiosInstance({
            url: '/users/' + encodeURIComponent(userId) + '/events',
            method: 'POST',
            data: {
                event_code: code,
                user_id: userId,
            },
        })
            .then(answer => {
                if (answer.error) throw answer;
                return answer;
            })
            .then(response => response.data);
    },
    joinEvent: function (userId, eventId) {
        return getAxiosInstance({
            url: ['', 'users', encodeURIComponent(userId), 'events'].join('/'),
            method: 'POST',
            data: {
                user_id: userId,
                event_id: eventId,
            },
        })
            .then(response => {
                if (response.data.error && response.data.error == 'event already exists') {
                    return getAxiosInstance({
                        url: ['', 'users', encodeURIComponent(userId), 'events', eventId].join('/'),
                        method: 'PUT',
                        data: {
                            is_joined: true,
                        },
                    });
                }
                return response;
            })
            .then(response => response.data);
    },
    leaveEvent: function (userId, eventId) {
        return getAxiosInstance({
            url: ['', 'users', encodeURIComponent(userId), 'events', eventId].join('/'),
            method: 'PUT',
            data: {
                is_joined: false,
            },
        }).then(response => response.data);
    },
    deleteFromEvent: function (userId, eventId) {
        return getAxiosInstance({
            url: ['', 'users', encodeURIComponent(userId), 'events', eventId].join('/'),
            method: 'DELETE',
            data: {},
        }).then(r => r.data);
    },
    fetchEnrichments: function (eventId, queryParams) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/enrichments' + encodeQueryParams(queryParams),
            method: 'GET',
        }).then(response => response.data);
    },
    fetchParticipants: function (eventId, queryParams) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/participants' + encodeQueryParams(queryParams),
            method: 'GET',
        }).then(response => response.data);
    },
    fetchProgram: function (eventId, options = {}) {
        const {userId, participantId, includeHidden, includeTasks} = options,
            params = {
                include_rounds: 'true',
            };

        if (userId) params.user_id = userId;
        if (participantId) params.participant_id = participantId;
        if (includeHidden) params.include_hidden = 'True'
        if (includeTasks) params.include_tasks = 'True'

        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/programs' + encodeQueryParams(params),
            method: 'GET',
        }).then(response => response.data);
    },
    fetchSpeakers: function (eventId) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/speakers',
            method: 'GET',
        }).then(response => response.data);
    },
    fetchNews: function (eventId, showHidden = false) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/news',
            method: 'GET',
            params: showHidden ? { show_hidden: true } : undefined,
        }).then(response => response.data);
    },
    fetchDirectoryItem: function (eventId, itemId) {
        return getAxiosInstance({
            url: `/events/${encodeURIComponent(eventId)}/exhibitors/${encodeURIComponent(itemId)}`,
            method: 'GET',
        }).then(r => r.data);
    },
    fetchExhibitors: function (eventId, parentId) {
        eventId = encodeURIComponent(eventId);
        if (parentId) {
            parentId = '?parent_id=' + encodeURIComponent(parentId);
        } else {
            parentId = '';
        }

        return getAxiosInstance({
            url: '/events/' + eventId + '/exhibitors' + parentId,
            method: 'GET',
        }).then(response => response.data);
    },
    saveEnrichmentAnswer: function (eventId, enrichmentQuestionId, answer, options = {}) {
        const {userId, participantId} = options,
            data = {
                answer,
            };

        if (!isArray(answer)) data.answer = [answer];
        if (userId) data.user_id = userId;
        if (participantId) data.participant_id = participantId;

        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/enrichments/' + encodeURIComponent(enrichmentQuestionId),
            method: 'PUT',
            /**
             * Description
             *
             * @property
             * @name data
             * @kind property
             * @memberof <unknown>.saveEnrichmentAnswer
             * @type {{ answer: any; }}
             */
            data,
        }).then(response => response.data);
    },
    alias: function (eventId, participantId) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/aliases',
            method: 'POST',
            data: {
                participant_id: participantId,
            },
        }).then(response => response.data);
    },
    fetchLocations: function (eventId) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/locations',
            method: 'GET',
        }).then(response => response.data);
    },

    fetchLocation: function (eventId, locationId) {
        return getAxiosInstance({
            url: '/events/' + encodeURIComponent(eventId) + '/locations/' + encodeURIComponent(locationId),
            method: 'GET',
        }).then(response => response.data);
    },
    sendMessageToSponsor: function (senderId, sponsorId, subject, message) {
        return getAxiosInstance({
            url: '/send/sponsor',
            method: 'POST',
            data: {
                sender_id: senderId,
                sponsor_id: sponsorId,
                subject,
                message,
            },
        }).then(response => response.data);
    },
    connections: function (eventId) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId), 'nconnections'].join('/'),
            method: 'GET',
        }).then(response => response.data);
    },
    poke: function (eventId, participantId, message) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId), 'poke'].join('/'),
            method: 'POST',
            data: {
                participant_id: participantId,
                message,
            },
        }).then(response => response.data);
    },
    fetchEventDataResources: function (eventId, params = {}, permission = {}) {
        return getAxiosInstance({
            url:
                ['', 'events', encodeURIComponent(eventId), 'fetch'].join('/') +
                `?include=${JSON.stringify(params)}&permission=${JSON.stringify(permission)}`,
            method: 'GET',
        }).then(response => response.data);
    },
    preparePage: function (eventId) {
        let params = {
                'event.welcome_text': true,
                'event.public_codes': true,
                'event.email_templates': true,
                event: true,
            },
            permission = {
                'event.edit_welcome': true,
                'event.view_content': true,
                'event.email_templates_create': true,
                'event.email_templates_edit': true,
                'participants.send_invites': true,
                'event.welcome_text': true,
                'event.codes': true,
            };
        return this.fetchEventDataResources(eventId, params, permission);
    },
    deletePublicCode: function (eventId, codeId) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId), 'codes', codeId].join('/'),
            method: 'DELETE',
            data: {},
        }).then(r => r.data);
    },
    addPublicCode: function (eventId, value) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId), 'codes'].join('/'),
            method: 'POST',
            data: {
                name: value,
                code: value,
            },
        }).then(r => r.data);
    },
    updateEventAttributes: function (eventId, data) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId)].join('/'),
            method: 'PUT',
            data: data,
        }).then(r => r.data);
    },
    performAction: function (eventId, type, data) {
        return getAxiosInstance({
            url: ['', 'events', encodeURIComponent(eventId), 'actions'].join('/'),
            method: 'POST',
            data: Object.assign(
                {
                    action: type,
                    date_updated: new Date().toISOString().replace(/\..*Z$/, ''), // server doesn't support ISO8601; truncating date to fit expected format "%Y-%m-%dT%H:%M:%S
                },
                data
            ),
        }).then(r => r.data);
    },
};
